import { Skeleton } from '@material-ui/lab'

import useStyles from './styles/GatewayRowMobile.styles'

const GatewayRowMobile = () => {
  const classes = useStyles()
  return (
    <div className={classes.tableRow}>
      <div className={classes.nameCell}>
        <Skeleton animation="wave" className={classes.skeleton} />
      </div>
      <div className={classes.nameCell}>
        <Skeleton animation="wave" className={classes.skeleton} />
      </div>
    </div>
  )
}
export default GatewayRowMobile
